import type { BootstrapData } from './types';

function matchesQuery(name: string, normalizedQuery: string) {
  return !normalizedQuery || name.toLowerCase().includes(normalizedQuery);
}

export function filterFriendDirectory(data: BootstrapData, query = '') {
  const normalizedQuery = query.trim().toLowerCase();
  const friends = Array.from(new Map((data.friends ?? []).map(friend => [friend.id, friend])).values())
    .filter(friend => matchesQuery(friend.name, normalizedQuery));
  const requests = Array.from(new Map((data.friendRequests ?? []).map(request => [request.user.id, request])).values())
    .filter(request => matchesQuery(request.user.name, normalizedQuery));
  const sentRequests = Array.from(new Map((data.sentFriendRequests ?? []).map(request => [request.user.id, request])).values())
    .filter(request => matchesQuery(request.user.name, normalizedQuery));
  const friendIds = new Set(friends.map(friend => friend.id));
  const requestUserIds = new Set(requests.map(request => request.user.id));
  const sentRequestUserIds = new Set(sentRequests.map(request => request.user.id));
  const users = Array.from(
    new Map(
      (data.appUsers ?? [])
        .filter(user => !friendIds.has(user.id) && !requestUserIds.has(user.id) && !sentRequestUserIds.has(user.id))
        .map(user => [user.id, user]),
    ).values(),
  ).filter(user => matchesQuery(user.name, normalizedQuery));

  return {
    friends,
    requests,
    sentRequests,
    users,
    normalizedQuery,
    totalCount: friends.length + requests.length + sentRequests.length + users.length,
  };
}
